import { render, staticRenderFns } from "./wall_of_support.vue?vue&type=template&id=33609010&"
import script from "./wall_of_support.vue?vue&type=script&lang=js&"
export * from "./wall_of_support.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports